import NewInput from 'app/components/NewInput';
import PageLoader from 'app/components/PageLoader';
import NumberInput from 'app/components/UI/NumberInput';
import BasePage from '../../router/BasePage';
import useUserProfilePage from './useUserProfilePage';

const UserProfilePage = () => {
  const { handleChange, values, error, pageLoading } = useUserProfilePage();

  return (
    <BasePage>
      <div className='blogsForm'>
        <div className='blogsForm_content'>
          <div className='headerback'>
            <div className='headerback_title'>User Profile Page</div>
          </div>

          <div className='inner-form-wrapper flex justify-between flex-wrap mb-4'>
            <div className='wd-50'>
              <NewInput
                label='Contact Person'
                id='name'
                type='text'
                placeholder='Contact Person'
                name='name'
                value={values?.name}
                disabled={true}
                onChange={handleChange}
                errorText={error?.name}
              />
            </div>
            <div className='wd-50'>
              <NumberInput
                label='Contact Number*'
                id='phone'
                placeholder='Contact Number'
                name='phone'
                disabled={true}
                value={values.phone}
                errorText={error?.phone}
                onChange={handleChange}
              />
            </div>
          </div>
          {/* <div className='d-flex justify-content-start'>
            <Button
              className='mt1'
              onClick={handleUserProfilePage}
              variant='Save'
              name='Submit'
              isDisabled={pageLoading ? true : false}
            />
            <Button
              className='mt1 cancel-button ms-2'
              onClick={() => navigate(-1)}
              variant='Cancel'
              name='Cancel'
              isDisabled={pageLoading ? true : false}
            />
          </div> */}
        </div>
        {pageLoading && <PageLoader pageLoading={pageLoading} />}
      </div>
    </BasePage>
  );
};

export default UserProfilePage;
